function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M224 40.727c-101.219 0-183.273 82.054-183.273 183.273s82.054 183.273 183.273 183.273c101.22 0 183.273-82.053 183.273-183.273s-82.053-183.273-183.273-183.273zM0 224c0-123.712 100.288-224 224-224s224 100.288 224 224c0 123.711-100.289 224-224 224s-224-100.289-224-224zM224 122.182c11.247 0 20.363 9.117 20.363 20.363v81.455c0 11.247-9.117 20.363-20.363 20.363s-20.363-9.117-20.363-20.363v-81.455c0-11.246 9.117-20.363 20.363-20.363zM203.637 305.455c0-11.247 9.117-20.363 20.363-20.363h0.203c11.247 0 20.363 9.117 20.363 20.363s-9.117 20.363-20.363 20.363h-0.203c-11.247 0-20.363-9.117-20.363-20.363z"
});

function SvgSxAlertCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 448,
    height: 448,
    viewBox: "0 0 448 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSxAlertCircle);
export default __webpack_public_path__ + "static/media/sx-alert-circle.d105bfc5.svg";
export { ForwardRef as ReactComponent };